type PaginationProps = {
    activePage: number;
    perPage: number;
    total?: number;
    setActivePage: any;
};

export default function Pagination({
    setActivePage,
    activePage,
    perPage,
    total,
}: PaginationProps) {
    const numOfPages = Math.ceil(total / perPage);

    const isActive = "text-blue bg-gray-light";
    const isNotActive =
        "text-gray-dark hover:text-black bg-white hover:bg-gray-light";
    return (
        <nav
            aria-label="Page navigation"
            className="block w-full mx-auto text-center mb-16"
        >
            <ul className="inline-flex -space-x-px">
                {activePage > 2 && (
                    <li>
                        <a
                            href="#"
                            onClick={() => setActivePage(1)}
                            className="py-2 px-3 ml-0 leading-tight text-gray-dark bg-white rounded-l-lg border border-gray hover:bg-gray-light hover:text-gray-dark dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                        >
                            1
                        </a>
                    </li>
                )}
                {Array(numOfPages)
                    .fill(0)
                    .map((_, i) => {
                        if (
                            (i < activePage - 3 && i === 0) ||
                            (i > activePage + 2 && i === numOfPages - 1)
                        )
                            return (
                                <li>
                                    <span className="py-2 px-3 border border-gray">
                                        ...
                                    </span>
                                </li>
                            );

                        if (i - 1 > activePage || i + 2 < activePage)
                            return null;

                        return (
                            <li>
                                <a
                                    href="#"
                                    onClick={() => setActivePage(i + 1)}
                                    className={`py-2 px-3 leading-tight border border-gray ${
                                        activePage === i + 1
                                            ? isActive
                                            : isNotActive
                                    }`}
                                >
                                    {i + 1}
                                </a>
                            </li>
                        );
                    })}
                {activePage + 2 < numOfPages && (
                    <li>
                        <a
                            href="#"
                            onClick={() => setActivePage(numOfPages)}
                            className="py-2 px-3 leading-tight text-gray-dark bg-white rounded-r-lg border border-gray hover:bg-gray-light hover:text-gray-dark dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                        >
                            {numOfPages}
                        </a>
                    </li>
                )}
            </ul>
        </nav>
    );
}
